<template>
  <form class="w-full overflow-hidden" @submit.prevent="onSubmit">
    <div class="vx-row">
      <div class="vx-col w-full md:w-auto mb-3 flex wrap">
        <vs-radio
          v-model="data.target"
          vs-value="house"
          class="mr-2"
          vs-name="dataTypeHouse"
          key="dataTypeHouse"
        >
          Дом
        </vs-radio>
      </div>
      <div class="vx-col w-full lg:w-auto mb-3 flex wrap">
        <vs-radio
          v-model="data.target"
          vs-value="accountNumbers"
          class="mr-2"
          vs-name="dataTypeHouse"
          key="dataTypeAccounts"
        >Лицевые счета
        </vs-radio>
      </div>
    </div>
    <div class="vx-col w-full mb-3">
      <elsa-v-select
        :options="houses"
        v-model="data.buildingId"
        label="address"
        :reduce="item => item.id"
        :clearable="false"
        html-label="Выберите дом"
        style-type="largeLabel"
      />
    </div>
    <div class="vx-row" v-if="data.target === 'accountNumbers'">
      <div class="vx-col w-full md:w-auto mb-3 flex wrap">
        <vs-radio v-model="data.isList" :vs-value="true" class="mr-2">Список</vs-radio>
      </div>
      <div class="vx-col w-full lg:w-auto mb-3 flex wrap">
        <vs-radio v-model="data.isList" :vs-value="false" class="mr-2">Диапазон</vs-radio>
      </div>
    </div>
    <div class="vx-col w-full mb-3" v-if="data.target === 'accountNumbers' && data.isList === true">
      <label for="data-accountNumbers">Лицевые счета через запятую</label>
      <vs-textarea
        class="w-full"
        id="data-accountNumbers"
        v-model.trim="data.accountNumbers"
        :class="{'has-error': errors.accountNumbers}"
        @input="errors.accountNumbers=false"
      />
      <div v-if="errors.accountNumbers">
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <div class="span-text-validation">
            Заполните лицевые счета
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full mb-3" v-if="data.target === 'accountNumbers' && data.isList === false">
      <label for="data-accountNumbers">Лицевые счета</label>
      <div class="flex items-center">
        <vs-input
          class="w-full flex-1"
          id="data-from"
          v-model.number="data.accountNumbersFrom"
          autocomplete="off"
          :danger="errors.accountNumbersFrom"
          danger-text="Заполните значение"
          @input="errors.accountNumbersFrom=false"
          type="number"
        />
        <span class="mx-4">-</span>
        <vs-input
          class="w-full flex-1"
          id="data-to"
          v-model.number="data.accountNumbersTo"
          autocomplete="off"
          :danger="errors.accountNumbersTo"
          danger-text="Заполните значение"
          @input="errors.accountNumbersTo=false"
          type="number"
        />
      </div>

    </div>
    <div class="vx-row">
      <div class="vx-col w-full mb-3">
        <elsa-v-select
          :options="apartmentTypes"
          v-model="data.apartmentType"
          label="name"
          :reduce="item => item.id"
          :clearable="false"
          html-label="Тип помещения"
          style-type="largeLabel"
        />
      </div>
    </div>
    <div class="vx-col w-full mb-3">
      <elsa-v-select
        :options="tariffs"
        v-model="data.tariffId"
        label="name"
        :reduce="item => item.id"
        :clearable="false"
        html-label="Тариф"
        style-type="largeLabel"
        :danger="errors.tariff"
        danger-text="Выберите тариф"
        @input="errors.tariff=false"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <label for="data-reason">Основание</label>
      <vs-textarea
        class="w-full"
        id="data-reason"
        v-model.trim="data.reason"
        :class="{'has-error': errors.reason}"
        @input="errors.reason=false"
      />
      <div v-if="errors.reason">
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <div class="span-text-validation">
            Заполните основание
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full mb-3">
      <label for="data-value">Значение</label>
      <vs-input
        class="w-full"
        id="data-value"
        v-model="data.value"
        v-currency
        autocomplete="off"
        :danger="errors.value"
        danger-text="Заполните значение"
        @input="errors.value=false"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <label for="data-date">Дата</label>
      <datepicker
        class="w-full"
        ref="dataMonth"
        v-model="data.date"
        format="MMMM yyyy"
        :minimumView="'month'"
        :maximumView="'year'"
        id="data-date"
        @input="errors.date=false"
        :class="{'has-error': errors.date}"
      >
      </datepicker>
      <div v-if="errors.date">
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <div class="span-text-validation">
            Выберите дату
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full mb-3">
      <label for="data-comment">Комментарий</label>
      <vs-textarea class="w-full" id="data-comment" v-model.trim="data.accountantComment" />
    </div>
    <div class="vx-col w-full mb-3">
      <div class="flex align-center">
        <div class="mr-4">Создать перерасчет даже если квитанции показаны</div>
        <vs-switch type="button" v-model="data.forced" />
      </div>
    </div>
    <div class="vx-col w-full mb-3">
      <label class="mb-2 block">Тип перерасчета</label>
      <vs-radio
        v-model="data.type"
        :key="`type-${type.value}`"
        :vs-value="type.value"
        class="w-full"
        v-for="type in recalculationTypes"
        vs-name="dataType"
      >
        {{ type.label }}
      </vs-radio>
      <div v-if="errors.type">
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <div class="span-text-validation">
            Выберите тип перерасчета
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full flex justify-center">
      <vs-button button="submit" type="filled" color="primary" class="mt-4 mr-4">Сохранить</vs-button>
    </div>
  </form>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import modal           from "@/mixins/modalContext";
import dateFormat      from "date-fns/format";

export default {
  name:   "RecalculationForm",
  mixins: [modal, notifyHttpError],
  props:  ['recalculation', 'onSave'],
  data() {
    return {
      data: {
        id:                 null,
        target:             null,
        buildingId:         null,
        isList:             null,
        accountNumbers:     null,
        accountNumbersFrom: null,
        accountNumbersTo:   null,
        apartmentType:      null,
        tariffId:           null,
        reason:             null,
        value:              null,
        date:               null,
        accountantComment:  null,
        forced:             null,
        type:               null,
      },

      errors: {
        accountNumbers:     false,
        accountNumbersFrom: false,
        accountNumbersTo:   false,
        tariff:             false,
        reason:             false,
        value:              false,
        date:               false,
        type:               false,
      },

      recalculationTypes: [
        { value: 0, label: 'Фиксированная сумма на лицевой счет' },
        { value: 1, label: 'По площади' },
        { value: 2, label: 'По постоянно зарегистрированным' },
        { value: 3, label: 'По фактически проживающим' },
        { value: 4, label: 'Перерасчет на сумму начислений' },
      ],

      tariffs: [],
    };
  },
  computed: {
    apartmentTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    houses() {
      return this.$store.getters['appUser/houses'];
    },
    hasError() {
      for (let key in this.errors) {
        if (this.errors[key] === true) return true;
      }
      return false;
    },
  },
  methods:  {
    onSubmit() {
      this.validate();
      if (this.hasError) return false;

      const { data } = this;

      const selection = data.target === 'house'
        ? 'all'
        : data.isList
          ? 'list'
          : 'range';

      const body = {
        apartmentsType:      data.apartmentType,
        apartmentsSelection: selection,
        apartmentsList:      data.accountNumbers && data.accountNumbers.split(',').map(number => number.trim()),
        apartmentsRangeFrom: data.accountNumbersFrom,
        apartmentsRangeTo:   data.accountNumbersTo,
        comment:             data.accountantComment,
        tariffs:             [{
          id:     data.tariffId,
          reason: data.reason,
          date:   data.date && dateFormat(data.date, 'MM.yyyy'),
          value:  data.value,
          type:   data.type,
          force:  data.forced,
        }],
      };
      this.onSave([body]);
      this.modalResolve();
    },

    resetErrors() {
      for (let key in this.errors) {
        this.errors[key] = false;
      }
    },


    validate() {
      this.resetErrors();
      const {
              target,
              isList,
              accountNumbers,
              accountNumbersFrom,
              accountNumbersTo,
              tariffId,
              reason,
              value,
              date,
              type,
            } = this.data;

      if (target === 'accountNumbers' && isList === true && (accountNumbers === null || !accountNumbers.trim().length)) {
        this.errors.accountNumbers = true;
      }

      if (target === 'accountNumbers' && isList === false && (accountNumbersFrom === null || !accountNumbersFrom.toString().trim().length)) {
        this.errors.accountNumbersFrom = true;
      }
      if (target === 'accountNumbers' && isList === false && (accountNumbersTo === null || !accountNumbersTo.toString().trim().length)) {
        this.errors.accountNumbersTo = true;
      }

      if (tariffId === null) this.errors.tariff = true;
      if (reason === null || !reason.trim().length) this.errors.reason = true;
      if (value === null || value === "") this.errors.value = true;
      if (date === null) this.errors.date = true;
      if (type === null) this.errors.type = true;
    },

    loadTariffs() {
      const { apartmentType, buildingId } = this.data;
      if (apartmentType === null || buildingId === null) return this.tariffs = [];
      const params = {
        apartments_type: apartmentType,
        buildings_id:    buildingId,
      };
      this.$http.get('tarifs', { params }).then(
        ( { data } ) => this.tariffs = data,
        this.notifyHttpError,
      );
    },
  },
  created() {
    const { recalculation } = this;
    if (recalculation) {
      const { list, buildings_id, tarif, type, comment, accountant_comment, value, month, tarifs_id } = recalculation;
      this.data = {
        ...this.data,
        target:             list === null ? 'house' : 'accountNumbers',
        buildingId:         buildings_id,
        isList:             list && !list.includes('-'),
        accountNumbers:     list && !list.includes('-') ? list : null,
        accountNumbersFrom: list && list.includes('-') ? list.split('-')[0] : null,
        accountNumbersTo:   list && list.includes('-') ? list.split('-')[1] : null,
        apartmentType:      tarif.apartments_type,
        type,
        reason:             comment,
        accountantComment:  accountant_comment,
        value,
        date:               this.$parseDateFromString(month),
        tariffId:           tarifs_id,
        forced:             false,
      };
    } else {
      this.data = {
        ...this.data,
        target:        'house',
        buildingId:    this.$store.getters['appUser/selectedHouse'].id,
        isList:        true,
        apartmentType: this.apartmentTypes[0].id,
        type:          0,
      };
    }
    this.loadTariffs();
  },
  watch: {
    'data.apartmentType'( val, prevVal ) {
      if (prevVal === null) return;
      this.loadTariffs();
      this.data.tariffId = null;
    },
    'data.buildingId'( val, prevVal ) {
      if (prevVal === null) return;
      this.loadTariffs();
      this.data.tariffId = null;
    },
  },
};
</script>

<style scoped>

</style>
